import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Modal,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const EditCountry = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [countryName, setCountryName] = useState('');
  const { countryId } = useParams();
  const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  // Static country data
  const [staticCountryData, setStaticCountryData] = useState([
    { countryId: 1, countryName: 'United States' },
    { countryId: 2, countryName: 'Canada' },
    { countryId: 3, countryName: 'United Kingdom' },
    { countryId: 4, countryName: 'Australia' },
    { countryId: 5, countryName: 'Germany' },
  ]);

  useEffect(() => {
    // Find the country to edit based on countryId
    const country = staticCountryData.find(
      country => country.countryId === parseInt(countryId)
    );
    if (country) {
      setCountryName(country.countryName);
    } else {
       setSnackbarMessage('Country not found');
       setOpenSnackbar(true);
       setSnackbarSeverity("error");
    }
  }, [countryId, staticCountryData]);

  const handleUpdate = () => {
    if (countryName) {
      // Update the static data
      const updatedData = staticCountryData.map(c =>
        c.countryId === parseInt(countryId)
          ? { ...c, countryName }
          : c
      );
      setStaticCountryData(updatedData);
      console.log('Updated country:', countryName);
      setShowSuccessModal(true);
    } else {
      setSnackbarMessage('Please enter a country name');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    navigate(-1);
  };

  return (
    <Container mt={4}>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Country
        </Typography>
      </Box>

      <Paper elevation={3} style={{ 
        padding: 16, 
        width: '100%', 
        margin: 'auto', 
        marginTop: 6, 
        backgroundColor: '#f8fdfeff' 
      }}>
        <div>
          <TextField
            label="Country Name"
            variant="outlined"
            fullWidth
            value={countryName}
            onChange={(e) => setCountryName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!countryName && "Enter Country Name"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{ 
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!countryName}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={handleModalClose}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography id="success-modal-title" variant="h6" component="h2">
            Success!
          </Typography>
          <Typography id="success-modal-description" sx={{ mt: 2 }}>
            Country name updated successfully.
          </Typography>
          <Button
            variant="contained"
            onClick={handleModalClose}
            sx={{ mt: 2 }}
          >
            OK
          </Button>
        </Box>
      </Modal>

      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditCountry;